import * as z from "zod";

/** A feature-flag key. Keys are an open set, defined next to their flags. */
export const featureFlagKeySchema = z.string();
